import { Stack } from "@mui/material";
import { reviews } from "../../constants/talent-profile";
import { ReviewCard } from "./Reviews/ReviewCard";

export default function Reviews() {
  return (
      <Stack direction="column" gap={2}>
        {reviews.map((_, index) => (
          <ReviewCard key={index} />
        ))}
      </Stack>
  );
}